import { CloseCircleMultipleOutlineIcon } from './CloseCircleMultipleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id B77F1750-F3D8-43A5-A2D1-EEF2E3EB584B
 * name close-circle-multiple-outline
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-circle-multiple-outline.svg
 * tags
 * - Form 
 */
export const CoinsCloseOutlineIcon = CloseCircleMultipleOutlineIcon;
export default CoinsCloseOutlineIcon